
            const data = {"name":"backlogAge/counter-2","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<rect pid=\"0\" x=\"3\" y=\"2\" width=\"1\" height=\"12\" rx=\".5\" _fill=\"#616161\"/><rect pid=\"1\" x=\"6\" y=\"2\" width=\"1\" height=\"12\" rx=\".5\" _fill=\"#616161\"/>","originalColors":[{"type":"fill","color":"#616161"},{"type":"fill","color":"#616161"}],"stopColors":[]}}
        
                    module.exports = data
                    